import styled from 'styled-components';
  
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

import { containerStyles } from '../pdp.styles';

export const Container = styled.div`
  ${containerStyles};
  padding: 30px 0;
  margin: 0 ${OFFSET.M};

  ${media.desktop} {
    grid-template-columns: 23% auto calc(24% - 200px);
  }

  @media (max-width: 768px) {
    border-bottom: 1px solid black;
  }
`;
